export const TIKTOK_URL_SCHEME = "snssdk1180://lynxview"

export const AFFILIATE_ROUTES = {
  BACK_URL: "/user/affiliate",
  REQUEST_SAMPLE: (id: string) => `/user/affiliate/request-sample/${id}`
} as const

export const COMMISSION_LABELS = {
  HIGH_COMMISSION: "Hoa hồng cao",
  COMMISSION_UP_TO: "Nhận hoa hồng đến",
  PER_ORDER: "/ đơn",
  EXCLUSIVE_HIGH_COMMISSION: "Tỷ lệ cao độc quyền",
  COMMISSION_RATE: "Tỷ lệ hoa hồng"
} as const

export const GUIDE_LABELS = {
  ADD_TO_SHOWCASE: "Thêm sản phẩm trưng bày",
  ADD_TO_TIKTOK: "Thêm sản phẩm trên Tiktok",
  CREATE_AD_VIDEO: "Tạo video quảng cáo",
  EARN_COMMISSION: "Kiếm hoa hồng",
  COPY_LINK: "Sao chép liên kết",
  GUIDE_TITLE: "Hướng dẫn gắn giỏ hàng"
} as const

export const UI_TEXT = {
  PRODUCT_DETAILS: "Thông tin sản phẩm",
  PRODUCT_DESCRIPTION: "Mô tả sản phẩm",
  SIMILAR_PRODUCTS: "Sản phẩm tương tự",
  PRODUCT_ID: "#ID",
  DISCOUNT_UP_TO: "Giảm đến",
  REVIEWS: "Đánh giá",
  NO_REVIEWS: "Chưa có đánh giá"
} as const
